import aboutImg from "../../../assets/Predict.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Banner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { token } = useSelector((state) => state.user);

  return (
    <div className="new-banner-full-wrapper">
      <div className="new-banner-container">

        {/* Background Image — absolute, fills entire section, fades from left */}
        <div className="new-banner-left-side">
          <img src={aboutImg} alt="Horse Rider" className="new-banner-hero-img" />
        </div>

        {/* Text Content — overlaid on the right */}
        <div className="new-banner-right-side">
          <div className="new-text-content-box">

            {/* Register Badge */}
            {token === null && (
              <button
                className="new-banner-reg-pill"
                onClick={() => navigate("/register")}
              >
                ✦ {t("RegisterNow")}
              </button>
            )}

            {/* Blue Divider */}
            <div className="new-banner-divider"></div>

            {/* Main Heading */}
            <h1 className="new-banner-main-title">
              {t("Predict")} &{" "}
              <span className="new-blue-text">
                {t("Win")}
                <svg
                  className="new-title-underline"
                  width="100%"
                  height="10"
                  viewBox="0 0 100 10"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0 5 Q 25 0, 50 5 T 100 5"
                    fill="none"
                    stroke="#2173d1"
                    strokeWidth="2.5"
                  />
                </svg>
              </span>
              <br />
              {t("Exclusive Prizes")}
            </h1>

            {/* Sub Text */}
            <p className="new-banner-sub-text">
              {t("free_features")}
            </p>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Banner;